import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { AreaCoverageOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const AreaCoverage: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-whole',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='area-coverage'
        name='areaCoverage'
        label='wizard.screen.otherFacilities.areaCoverage'
        value={insertionData.areaCoverage}
        noInformation={AreaCoverageOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.areaCoverages',
          options: Object.keys(AreaCoverageOption),
        }}
        onChange={(value) => onChange({ screen: screenName, property: 'areaCoverage' }, value.value!)}
        allowEmpty
      />
    </div>
  )
}

export default AreaCoverage
